module.exports = __webpack_public_path__ + "img/3_4.b7a188d1.png";